/// ///////////////////////////////////////////////////////////////////////////
//  Copyright (C) 2013 by sanpolo CO.LTD                                    //
//                                                                          //
//  This file is part of WIDE                                               //
//                                                                          //
//  You should have received a copy of the WIDE License along with this     //
//  program.  If not, see <http://www.wware.org/wide/license.html>.         //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// ///////////////////////////////////////////////////////////////////////////
// Created At : 2019-03-11T13:12:30.845Z by lizhutang (lizhutang@spolo.org)

'use strict'

function extendComps (wwInst) {
  // let domc = wwInst.editor.DomComponents
}

function setup (wwInst) {
  let bm = wwInst.editor.BlockManager
  extendComps(wwInst)
  // console.log('table=', bm.get('table'))
  bm.add('table', {
    category: 'Basic',
    attributes: { class: 'fa fa-table' },
    label: '表格',
    content: `<table class="table">
             <thead>
                 <tr>
                 <th scope="col" data-child-element="basic"><div>#</div></th>
                 <th scope="col" data-child-element="basic"><div>姓名</div></th>
                 <th scope="col" data-child-element="basic"><div>年龄</div></th>
                 <th scope="col" data-child-element="basic"><div>性别</div></th>
                 </tr>
             </thead>
             <tbody>
                 <tr>
                 <th scope="row" data-child-element="basic"><div>1</div></th>
                 <td data-child-element="basic"><div>张三</div></td>
                 <td data-child-element="basic"><div>21</div></td>
                 <td data-child-element="basic"><div>男</div></td>
                 </tr>
                 <tr>
                 <th scope="row" data-child-element="basic"><div>2</div></th>
                 <td data-child-element="basic"><div>王雨燕</div></td>
                 <td data-child-element="basic"><div>22</div></td>
                 <td data-child-element="basic"><div>女</div></td>
                 </tr>
                 <tr>
                 <th scope="row" data-child-element="basic"><div>3</div></th>
                 <td data-child-element="basic"><div>李四</div></td>
                 <td data-child-element="basic"><div>19</div></td>
                 <td data-child-element="basic"><div>男</div></td>
                 </tr>
             </tbody>
             <tfoot>
                 <tr>
                 <th scope="col" data-child-element="basic"><div>#</div></th>
                 <th scope="col" data-child-element="basic"><div>姓名</div></th>
                 <th scope="col" data-child-element="basic"><div>年龄</div></th>
                 <th scope="col" data-child-element="basic"><div>性别</div></th>
                 </tr>
             </tfoot>
             </table>`
  })

  wwInst.editor.BlockManager.render([
    bm.get('container').set('category', wwjs.i18n('布局')),
    bm.get('row').set('category', wwjs.i18n('布局')),
    bm.get('column').set('category', wwjs.i18n('布局')),
    bm.get('column_break').set('category', wwjs.i18n('布局')),
    bm.get('stage').set('category', wwjs.i18n('布局')),
    bm.get('layer').set('category', wwjs.i18n('布局')),
    bm.get('frame').set('category', wwjs.i18n('布局')),
    bm.get('absolute').set('category', wwjs.i18n('布局')),

    bm.get('text').set('category', '基础元素'),
    bm.get('paragraph').set('category', '基础元素'),
    bm.get('header').set('category', '基础元素'),
    bm.get('image').set('category', '基础元素'),
    bm.get('link').set('category', '基础元素'),
    bm.get('table').set('category', '基础元素')

    // 表单元素
    // 扩展元素
  ])
}

export default setup
